import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// Import the logo directly from assets folder
import logoImage from '../assets/B01_logo_white.png';

/**
 * Logo component with direct import from assets
 */
const Logo = () => {
  const [showImage, setShowImage] = useState(true);
  
  const handleImageError = () => {
    console.log('Logo image failed to load, using text instead');
    setShowImage(false);
  };
  
  return (
    <Link to="/" className="flex items-center">
      {showImage ? (
        <img 
          src={logoImage}
          alt="Biotech01 Logo" 
          className="h-16 w-auto"
          onError={handleImageError}
        />
      ) : (
        <div className="flex items-center text-white font-bold">
          <span className="text-2xl mr-1">B</span>
          <span className="text-2xl mr-2">01</span>
          <span className="text-lg hidden sm:inline">BIOTECH</span>
        </div>
      )}
    </Link>
  );
};

export default Logo; 